import { FolderPlayOutlineIcon } from './FolderPlayOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 63119A3C-5E35-4BC5-9DA6-74EB4DD748DB
 * name folder-play-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-play-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderVideoOutlineIcon = FolderPlayOutlineIcon;
export default FolderVideoOutlineIcon